import { useMemo } from 'react';
import { useAuth } from './AuthContext';
import { hasSupabaseConfig } from '../lib/supabaseClient';
import { membershipHasModule } from './moduleAccess';

/**
 * Module access for the active organization.
 * When Supabase is not configured (local skip-auth mode), all modules are allowed.
 */
export function useModuleAccess() {
  const { activeMembership, hasModule, activeOrganizationId } = useAuth();
  const skipAuth = !hasSupabaseConfig();

  return useMemo(
    () => ({
      skipAuth,
      organizationId: activeOrganizationId,
      role: skipAuth ? 'Admin' : activeMembership?.role ?? null,
      canMeeting: skipAuth || hasModule('meeting'),
      canCommittees: skipAuth || hasModule('committees'),
      canElections: skipAuth || hasModule('elections'),
      canAdmin: skipAuth || hasModule('admin'),
      hasModule: (name) => skipAuth || hasModule(name),
      membershipHasModule,
    }),
    [skipAuth, activeOrganizationId, activeMembership, hasModule]
  );
}
